import { handleRowndTokenCallback } from '../../remix/server/withRowndActionHandler';
import { ROWND_COOKIE_ID, ROWND_TOKEN_CALLBACK_PATH } from '../../ssr/server/cookie';
import cookie from 'cookie';
import { getRowndAuthenticationStatus } from '../../ssr/server/token';

type NextResponse = any;
type NextRequest = any;

export const withRowndMiddleware = (
  middleware: (request: any) => NextResponse
) => {
  return (request: NextRequest) => {
    if (request?.nextUrl?.pathname?.startsWith(ROWND_TOKEN_CALLBACK_PATH)) {
      return handleRowndTokenCallback(request)
    }

    const cookies = cookie.parse(request.headers.cookie || '');

    // console.log('rownd cookie', cookies[ROWND_COOKIE_ID]);

    return getRowndAuthenticationStatus(cookies[ROWND_COOKIE_ID] || null).then((tokenInfo) => {
      // console.log('tokenInfo', tokenInfo);
      request.auth = tokenInfo;

      return middleware(request);
    });
  };
};
